import axios from "axios";
const BACKEND_URL = process.env.REACT_APP_API_URL;
const API_URL = `${BACKEND_URL}/reviews`;

const submitReview = async (bookingId, ratings, comment) => {
  const averageRating = ratings.reduce((acc, rating) => acc + rating.value, 0) / ratings.length;

  const response = await axios.post(`${API_URL}/booking/${bookingId}`, {
    average_rating: averageRating,
    comment: comment,
  });
  return response.data;
};

const checkReviewExists = async (bookingId) => {
  const response = await axios.get(`${API_URL}/booking/${bookingId}/exists`);
  return response.data.exists;
};

const reviewService = {
  submitReview,
  checkReviewExists,
};

export default reviewService;
